export default __webpack_public_path__ + "static/media/icon_terimauang_inactive_new.bf2f8c9a.svg";